<script>
import { mapGetters } from 'vuex'
import { getProvinces } from '@/api/assetwise'

export default {
  data() {
    return {
      items: [{ value: '', text: this.$t('All') }],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const items = await getProvinces({
          page_id: this.selectedBot.pageid
        }).then((response) => {
          const { data = [] } = response.data
          return data
        })

        this.items = [
          { value: '', text: this.$t('All') },
          ...items.map((item) => ({
            value: item.ProvinceID,
            text: item.ProvinceName
          }))
        ]
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      options: this.items,
      loading: this.isLoading
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/providers/ProvinceOptionListProvider.vue